import React from 'react';
import fitLogo from '../../assets/fit-logo.png';

const Logo = ({ size = 'normal', onClick }) => {
  const isLarge = size === 'large';
  
  return (
    <div className={`brand-logo flex items-center ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
      <img 
        src={fitLogo} 
        alt="FiT Engineering College Logo" 
        style={{ height: isLarge ? '64px' : '50px', width: 'auto' }}
        className="object-contain"
      />
    </div>
  );
};

export default Logo;